module.exports = __webpack_public_path__ + "img/staticcling.0c1daf09.png";